const TipoUsuarioList = () =>
  import("~/components/Views/Prova/TipoUsuario/List");
const TipoUsuarioNew = () => import("~/components/Views/Prova/TipoUsuario/New");

import auth from "~/middleware/auth";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Administração", link: "" }
];

export const tipoUsuario = [
  {
    path: "administracao/tipo-usuario",
    component: TipoUsuarioList,
    name: "Tipo de Usuário",
    meta: {
      title: "Tipo de Usuário",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/tipo-usuario/new",
    component: TipoUsuarioNew,
    name: "Novo Tipo de Usuário",
    meta: {
      title: "Novo Tipo de Usuário",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  },
  {
    path: "administracao/tipo-usuario/:id",
    component: TipoUsuarioNew,
    name: "Alterar Tipo de Usuário",
    meta: {
      title: "Alterar Tipo de Usuário",
      middleware: [auth, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/administracao/tipoUsuario.js